import React from "react";
import { Moon, Sun } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { THEME_LABELS, useWorkspaceTheme } from "@/lib/workspaceTheme";

export default function ThemeSwitcher({ publicSite = false }) {
  const { lang } = useI18n();
  const { theme, setTheme } = useWorkspaceTheme();
  const labels = publicSite ? THEME_LABELS.en : THEME_LABELS[lang] || THEME_LABELS.en;
  return (
    <div className={`td-theme-switcher${publicSite ? " td-public-theme-switcher" : ""}`} role="group" aria-label={labels.title}>
      {[{ value: "dark", Icon: Moon }, { value: "light", Icon: Sun }].map(({ value, Icon }) => (
        <button key={value} type="button" aria-pressed={theme === value}
          data-testid={`${publicSite ? "public" : "workspace"}-theme-${value}`} onClick={() => setTheme(value)}>
          <Icon size={18} aria-hidden="true" />
          <span>{labels[value]}</span>
        </button>
      ))}
    </div>
  );
}
